import { Model } from "@lernetz/ts-lib";
import { View, ViewConfig } from "@lernetz/ts-lib/src/view/View";
import { viewportDimension } from "@lernetz/ts-lib/src/dom";
import { route } from "@lernetz/ts-lib/src/Setup";

export class Image extends Model {
    route:string;
    viewWidth:number;
    viewHeight:number;
    [key:string]:any;
    srcset:{[key:string]:{[key:string]:string}};
}

export class ImageView extends View<Image> {

    errorhandle;

    constructor( config?:ViewConfig<Image> ) {
        super( { data:new Image( { route:'image' } ), template:'', ...config } );
    }

    init() {
        this.setAttributes( [ 'width', 'height' ] );

        // inject
        let viewport = viewportDimension();
        this.data.viewWidth = viewport.width;
        this.data.viewHeight = viewport.height;

        // register for image load
        this.errorhandle = this.onError.bind( this );
        this.node.addEventListener( 'error', this.errorhandle );

        // load image
        this.load();
    }

    deinit() {
        this.node.removeEventListener( 'error', this.errorhandle );
    }

    load() {
        this.node.setAttribute( 'src', route( this.data.route, this.data ).url() );

        if( this.data.srcset ) {

            // loop over all conditions an generate routes
            let srcset = Object.keys( this.data.srcset ).map( condition => {
                return route( this.data.route, { ...this.data, ...this.data.srcset[ condition ] } ).url() + ' ' + condition;
            }).join( ',' );

            this.node.setAttribute( 'srcset', srcset );

        }
    }

    onError( e ) {
        this.node.setAttribute( 'src', 'https://fakeimg.pl/500x300/?text=Error' );
    }

    setAttributes( names ) {
        for( const name of names ) {
            if( this.data[ name ] ) this.node.setAttribute( name, this.data[ name ] );
        }
    }
}
